<template>
  <div class="licenseWrap" v-loading="loading">
    <div class="licenseConentWrap">
      <div class="licenseTitle">
        <span>紫光云License 激活申请</span
        ><span
          v-if="$route.path.includes('activeDetail')"
          style="font-size: 14px; color: #606266"
        >
          &nbsp;&nbsp;/ &nbsp;&nbsp;详情信息</span
        >
        <el-button
          type="primary"
          plain
          :loading="loading"
          @click="seeHelp"
          style="float: right"
          >查看帮助</el-button
        >
      </div>
      <div class="licenseHeader" v-if="!$route.path.includes('activeDetail')">
        <nav-list
          class="navList"
          :stepList="stepList"
          :currentStep="currentStep"
        ></nav-list>
      </div>
      <div class="licenseContent" v-if="!$route.path.includes('activeDetail')">
        <components :is="comList[currentStep].com" ref="commonRef"></components>
      </div>
      <div v-if="$route.path.includes('activeDetail')">
        <active-detail ref="activeDetail"></active-detail>
      </div>
    </div>
    <div class="licenseFooter">
      <div class="footerWrap">
        <clause-tip
          ref="clauseTip"
          v-if="currentStep === 1"
          :currentStep="currentStep"
        >
          <div>
            我已了解：授权码与硬件设备绑定后，对应的授权就与硬件设备进行了绑定。
          </div>
          <div>
            进行绑定操作时，请确保输入信息的准确，以免因授权码与硬件设备的错误绑定，导致目标设备没有获得正确的授权。
          </div>
        </clause-tip>
        <clause-tip
          ref="clauseTip"
          v-if="currentStep === 3 && !activateState"
          :currentStep="currentStep"
        >
          <div>
            已阅读并同意法律声明所述服务条款各项内容<span
              class="clickText"
              @click.stop="clickTextFour"
              >紫光云授权服务门户法律声明</span
            >
          </div>
        </clause-tip>
        <div class="footerRight">
          <el-button
            type="primary"
            plain
            v-show="currentStep !== 0 && !activateState"
            @click="previousPage"
            >上一步</el-button
          >
          <el-button
            type="primary"
            v-show="
              !$route.path.includes('activeDetail') &&
              currentStep !== stepList.length - 1
            "
            @click="nextPage"
            >下一步</el-button
          >
          <el-button
            type="primary"
            v-show="currentStep === stepList.length - 1 && !activateState"
            @click="activeLicenseFuc"
            >确认并激活 License</el-button
          >
          <el-button
            type="primary"
            plain
            v-if="activateState || $route.path.includes('activeDetail')"
            @click="getActiveFile"
            >获取激活文件</el-button
          >
          <el-button
            type="primary"
            v-if="activateState || $route.path.includes('activeDetail')"
            @click="continueActive"
            >继续激活</el-button
          >
        </div>
      </div>
    </div>
    <dialog-common
      v-if="dialogCommonVisible"
      :visible.sync="dialogCommonVisible"
      title="获取激活文件"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose"
    >
      <div>
        <span style="margin-right: 10px">请选择激活文件获取方式：</span>
        <el-checkbox-group style="display: inline-block" v-model="checkList"
          ><el-checkbox label="下载激活文件"></el-checkbox
          ><el-checkbox label="邮件发送激活文件"></el-checkbox
        ></el-checkbox-group>
      </div>
    </dialog-common>
    <dialog-common
      v-if="dialogActiveVisible"
      :visible.sync="dialogActiveVisible"
      title="确认并激活License"
      @handleConfirm="handleConfirmActive"
      @handleClose="handleCloseActive"
      :loading="loading"
    >
      <img
        width="16"
        height="16"
        style="margin-right: 8px"
        src="../../assets/img/warn.svg"
        alt=""
      />
      <span>核对本次激活中所有录入的信息真实有效，确认无误。</span>
    </dialog-common>
  </div>
</template>
<script>
import zgyLicenseReq from '~/request/zgyLicenseReq';
import navList from '~/components/nav-list.vue';
import AddInfo from './Components/AddInfo.vue';
import BindDevice from './Components/BindDevice.vue';
import UserInfo from './Components/UserInfo.vue';
import clauseTip from '~/components/clause-tip-zgy.vue';
import ConfirmActive from './Components/ConfirmActive.vue';
import ActiveDetail from './Components/ActiveDetail.vue';
import DialogCommon from './Components/Dialog/DialogCommon';
export default {
  components: {
    navList,
    AddInfo,
    BindDevice,
    UserInfo,
    clauseTip,
    ConfirmActive,
    ActiveDetail,
    DialogCommon,
  },
  data() {
    return {
      loading: false,
      // 校验项
      vailList: [['commonRef'], ['commonRef', 'clauseTip'], ['commonRef']],
      comList: [
        {
          com: 'addInfo',
          vailAfter: true,
        },
        {
          com: 'bindDevice',
          vailAfter: true,
        },
        {
          com: 'userInfo',
          vailAfter: true,
        },
        {
          com: 'confirmActive',
          vailAfter: false,
        },
      ],
      currentStep: 0,
      stepList: [
        { label: '第一步：输入授权信息' },
        { label: '第二步：绑定硬件设备' },
        { label: '第三步：用户数据录入' },
        { label: '第四步：确认并激活' },
      ],
      // 激活状态
      activateState: false,
      dialogCommonVisible: false,
      dialogActiveVisible: false,
      checkList: ['下载激活文件'],
      zipUrl: '',
    };
  },

  methods: {
    //第4步--法律声明
    clickTextFour() {
      window.open(`${location.origin}/document/license_activation_legal.html`);
    },
    //第4步--继续激活
    continueActive() {
      this.activateState = false;
      if (this.$route.path.includes('activeDetail')) {
        this.$router.go(-1);
      } else {
        this.currentStep = 0;
      }
    },
    //上一步
    previousPage() {
      //保证回退到第一步时刷新不丢失本次的流程
      sessionStorage.setItem('previousProcessFlag', true);
      this.currentStep -= 1;      
    },
    //下一步
    nextPage() {
      const hanlderRef = this.vailList[this.currentStep];
      let refList = [];
      if (Array.isArray(hanlderRef)) {
        refList = hanlderRef.map(hander => this.$refs[hander].getVail());
      }
      Promise.all(refList)
        .then(() => {
          let fuc = '';
          if (this.comList[this.currentStep].vailAfter) {
            fuc = this.comList[this.currentStep].com + 'Vail';
          }
          if (fuc) {
            this[fuc]();
          } else {
            this.currentStep += 1;
          }
        })
        .catch(() => {});
    },
    //在第一页点下一步
    addInfoVail() {
      const param = {
        processNo: sessionStorage.getItem('processNo'),
        currentStep: '1',
      };
      this.loading = true;
      zgyLicenseReq
        .nextStep(param)
        .then(res => {
          this.loading = false;
          if (res.status) {
            this.currentStep += 1;
          } else {
            this.$notify({
              title: '失败',
              message: res.msg,
              type: 'error',
            });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },
    //在第二页点下一步
    bindDeviceVail() {
      const param = {
        processNo: sessionStorage.getItem('processNo'),
        currentStep: '2',
      };
      this.loading = true;
      zgyLicenseReq
        .nextStep(param)
        .then(res => {
          this.loading = false;
          if (res.status) {
            this.currentStep += 1;
          } else {
            this.$notify({
              title: '失败',
              message: res.msg,
              type: 'error',
            });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },
    //在第三页点下一步
    userInfoVail() {
      let param = this.$refs.commonRef.getData();
      param.processNo = sessionStorage.getItem('processNo');
      this.loading = true;
      zgyLicenseReq
        .saveUser(param)
        .then(res => {
          if (res.status) {
            const paramStep = {
              processNo: sessionStorage.getItem('processNo'),
              currentStep: '3',
            };
            zgyLicenseReq.nextStep(paramStep).then(res => {
              this.loading = false;
              if (res.status) {
                this.currentStep += 1;
              } else {
                this.$notify({
                  title: '失败',
                  message: res.msg,
                  type: 'error',
                });
              }
            });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },
    //确认并激活license-注意此时拿掉了processNo，添加了用于激活的processNoForEmail
    activeLicenseFuc() {
      this.$refs['clauseTip'].getVail().then(() => {
        this.dialogActiveVisible = true;
      });
    },
    handleConfirmActive() {
      const processNo = sessionStorage.getItem('processNo');
      this.loading = true;
      zgyLicenseReq
        .confirmActivate(processNo)
        .then(res => {
          this.loading = false;
          if (res.status) {
            this.handleCloseActive();
            this.activateState = true;
            this.$refs.commonRef.updateTable();
            sessionStorage.removeItem('processNo');
            sessionStorage.setItem('processNoForEmail', processNo);
            sessionStorage.setItem('activeFileUrl', res.res);
            this.$notify({
              title: '成功',
              message: '激活完毕',
              type: 'success',
            });
          } else {
            this.$notify({
              title: '失败',
              message: '激活失败',
              type: 'error',
            });
          }
        })
        .catch(err => {
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },
    handleCloseActive() {
      this.dialogActiveVisible = false;
    },
    //查看帮助
    seeHelp() {
      if(this.currentStep == 0)window.open(`${location.origin}/document/show-758611388.html`);
      if(this.currentStep == 1)window.open(`${location.origin}/document/show-758711389.html`);
      if(this.currentStep == 2)window.open(`${location.origin}/document/show-758811390.html`);
      if(this.currentStep == 3)window.open(`${location.origin}/document/show-758911391.html`);
    },
    //获取激活文件
    getActiveFile() {
      if (this.$route.path.includes('activeDetail')) {
        this.$refs.activeDetail.getActiveFile();
      } else {
        this.dialogCommonVisible = true;
        this.checkList = ['下载激活文件'];
      }
    },
    //激活文件弹框
    handleClose() {
      this.dialogCommonVisible = false;
    },
    handleConfirm() {
      if (!this.checkList.length) {
        this.handleClose();
      } else {
        if (this.checkList.includes('下载激活文件')) {
          window.location.href = sessionStorage.getItem('activeFileUrl');
        }
        if (this.checkList.includes('邮件发送激活文件')) {
          let customerId = sessionStorage.getItem('customerId');
          let zipUrl = sessionStorage.getItem('activeFileUrl');
          let processNo = sessionStorage.getItem('processNoForEmail');
          zgyLicenseReq
            .sendEmailToActive(customerId, zipUrl, processNo)
            .then(res => {
              if (res.status) {
                this.handleClose();
                this.$notify({
                  title: '成功',
                  message: '邮件发送激活文件成功',
                  type: 'success',
                });
              } else {
                this.$notify({
                  title: '失败',
                  message: res.msg || '邮件发送激活文件失败',
                  type: 'error',
                });
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.licenseWrap {
  background: #ffffff;
  // margin: 20px;
  height: 100%;
  // max-width: 1200px;
  display: flex;
  flex-direction: column;
  .licenseConentWrap {
    .rightFlexItem {
    }
    margin: 0 auto;
    // margin: 0 291px;
    // height: 100%;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1200px;
    }
    // 小于 1532 px
    @media screen and (max-width: 1532px) {
      margin-top: 32px;
    }

    // min-width: 1200px;
    .licenseTitle {
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      padding: 20px 0;
      .clickText {
        cursor: pointer;
        color: @currentColor;
      }
      .licenseTitleIcon {
        margin-left: 7px;
        cursor: pointer;
        font-size: 16px;
      }
    }
    .licenseHeader {
      width: 100%;
      height: 34px;
      line-height: 34px;
    }
    .licenseContent {
      flex: 1;
      padding: 16px 0;
    }
  }
  .licenseFooter {
    z-index: 99;
    // padding: 0 291px;
    width: 100%;
    height: 66px;
    background: #ffffff;
    box-shadow: 0px -4px 8px 0px rgba(66, 44, 82, 0.07);
    // text-align: right;
    display: flex;
    align-items: center;
    .footerWrap {
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media (min-width: 768px) {
        width: 750px;
      }
      @media (min-width: 992px) {
        width: 970px;
      }
      @media (min-width: 1200px) {
        width: 1200px;
      }
    }

    // min-width: 1200px;
    .clickText {
      cursor: pointer;
      color: @currentColor;
    }
    .footerRight {
      flex: 1;
      text-align: right;
      .verifyCode {
        // margin-right: 15px;
      }
    }
  }
}
</style>